<template>
  <VDialog :value="value" max-width="480" @input="$emit('input', $event)">
    <VCard class="pa-4">
      <div class="d-flex justify-space-between align-items-center">
        <div class="heading-6 pb-4">{{ $t('nightRiderLink.checkoutAddCardLinkText') }}</div>
        <VBtn
          class="grey-lighten-4 box-shadow-elevation-6 mb-5"
          icon
          @click.stop="onLater"
        >
          <VIcon color="textPrimary">
            mdi-close
          </VIcon>
        </VBtn>
      </div>
      <p class="body-2 pb-4 mb-0">{{ $t('nightRiderLink.settingsNoCardSubtitle') }}</p>
      <div v-if="infoLinkUrl" class="pb-4 d-flex align-items-center">
        <VIcon class="secondary--text">
          mdi-help-circle-outline
        </VIcon>
        <a
          :href="infoLinkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="body-2 secondary--text text-decoration-underline ml-2"
        >
          {{ $t('nightRiderLink.inviteLinkText') }}
        </a>
      </div>
      <div
        class="pt-2 d-flex flex-row flex-nowrap align-stretch night-card-invite-actions"
        style="width: 100%; column-gap: 8px;"
      >
        <div class="night-card-invite-actions__cell">
          <VBtn
            class="w-100"
            outlined
            data-test="night-card-invite-later"
            @click="onLater"
          >
            <span class="button">{{ $t('nightRiderLink.inviteLater') }}</span>
          </VBtn>
        </div>
        <div class="night-card-invite-actions__cell">
          <VBtn
            class="w-100 text-decoration-none"
            color="brandingPrimary"
            data-test="night-card-invite-go-settings"
            dark
            @click="goSettings"
          >
            <span class="button">{{ $t('nightRiderLink.inviteGoToSettings') }}</span>
          </VBtn>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SNightCardInviteDialog',
};
</script>

<script setup lang="ts">
defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  infoLinkUrl: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['later', 'input', 'go-to-settings']);

function onLater() {
  emit('later');
  emit('input', false);
}

function close() {
  emit('input', false);
}

function goSettings() {
  emit('go-to-settings');
  emit('input', false);
}
</script>

<style scoped>
.night-card-invite-actions {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  box-sizing: border-box;
}

.night-card-invite-actions__cell {
  flex: 1 1 0;
  min-width: 0;
}

.night-card-invite-actions .button {
  text-transform: uppercase;
}
</style>
